export default "__VITE_ASSET__147cc455__"